import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const ServicesStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '&.MuiFormLabel-root': {
        color: theme.palette.form.labelColor,
        fontSize: theme.typography.appFontSize,
        paddingLeft: '16px !important',
      },
      '&.Mui-focused': {
        color: theme.palette.primary.main,
        paddingLeft: '0 !important',
      },
      '&.MuiInputLabel-shrink': {
        paddingLeft: '0 !important',
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiInputBase-input': {
      fontSize: theme.typography.appFontSize,
      paddingLeft: '16px !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme.typography.pxToRem(11),
    },
  },
}))(TextField);

export default ServicesStyled;
